import { createContext, useContext } from "react";
import type { Definition } from "../types";

/** What the pieces of the builder (the toolbar, a toast with an Undo button) may do with the edit history. */
export interface HistoryApi {
  /** What Undo / Redo would take back / bring back; `null` when there is nothing to undo / redo. */
  undoLabel: string | null;
  redoLabel: string | null;
  undo: () => void;
  redo: () => void;
  /** The definition of the edit made last, available right after the edit (before the next render). */
  latest: () => Definition;
  /** Undoes the last edit only if it produced `definition`: a toast's Undo must not take back something made after it. */
  undoIfCurrent: (definition: Definition) => void;
  /** Changes with every undo and redo: a sheet that was open on the old version closes. */
  epoch: number;
  /** Words for what the last undo / redo did, for a live region. */
  announcement: string;
}

export const HistoryContext = createContext<HistoryApi | null>(null);

/** The edit history of the builder, or `null` where the builder shows a version nobody edits. */
export const useHistory = (): HistoryApi | null => useContext(HistoryContext);
